import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function AdminLogin(){
  const nav = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(''); setLoading(true);
    try {
      const res = await axios.post(`${API}/admin/login`, { email, password });
      localStorage.setItem('nc_admin_token', res.data.token);
      localStorage.setItem('nc_admin_email', res.data.email);
      nav('/admin');
    } catch (e) {
      setErr(e?.response?.data?.detail || 'Login failed');
    } finally { setLoading(false); }
  };

  return (
    <div className="admin-login-wrap">
      <Helmet>
        <title>Admin login — Nomad Compass</title>
        <meta name="robots" content="noindex,nofollow" />
      </Helmet>
      <form onSubmit={submit} className="admin-login-card">
        <Link to="/" className="brand" style={{ marginBottom: 24 }}>
          <img className="brand-logo" src="/nomad-compass-logo.png" alt="Nomad Compass" width="600" height="411" />
        </Link>
        <div className="form-title" style={{ marginTop: 12 }}>Admin access</div>
        <div className="form-sub">Enter the admin credentials to view enquiries.</div>
        {err && <div className="admin-error" data-testid="login-error">{err}</div>}
        <div className="form-field">
          <label>Email</label>
          <input type="email" value={email} onChange={e => setEmail(e.target.value)} required data-testid="admin-email" />
        </div>
        <div className="form-field">
          <label>Password</label>
          <input type="password" value={password} onChange={e => setPassword(e.target.value)} required data-testid="admin-password" />
        </div>
        <button type="submit" className="btn-submit" disabled={loading} data-testid="admin-submit">{loading ? 'Signing in...' : 'Sign in'}</button>
      </form>
    </div>
  );
}
